import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { useId as createId } from '../../../hooks';

export default function RadioPill({
    id: userId,
    name,
    value,
    className,
    isInvalid,
    isDisabled,
    isRequired,
    isChecked,
    children,
    innerRef,
    onChange,
    onBlur,
    ...rest
}) {
    const id = useMemo(() => createId(userId), [userId]);

    return (
        <label
            data-component="RadioPill"
            className={cx(className, {
                invalid: isInvalid,
            })}
            htmlFor={id}
            ref={innerRef}
            {...rest}
        >
            <input
                type="radio"
                id={id}
                name={name}
                required={isRequired}
                disabled={isDisabled}
                value={value}
                checked={isChecked}
                className="rec-sr-only"
                onChange={onChange}
                onBlur={onBlur}
                aria-describedby={rest['aria-describedby']}
            />
            <span data-radio-pill-contents>{children}</span>
        </label>
    );
}

RadioPill.propTypes = {
    /** Input id */
    id: PropTypes.string,

    /** Pill label */
    children: PropTypes.node,

    /** The input value */
    value: PropTypes.string,

    /** Additional class added to the outer container */
    className: PropTypes.string,

    /** Marks pill as invalid */
    isInvalid: PropTypes.bool,

    /** Marks pill as disabled */
    isDisabled: PropTypes.bool,

    /** Marks pill as required */
    isRequired: PropTypes.bool,

    /** Marks pill as selected. Must also include an onChange prop */
    isChecked: PropTypes.bool,

    /** Change handler. Must also include a value for isChecked */
    onChange: PropTypes.func,

    /** Blur event handler */
    onBlur: PropTypes.func,

    /** Ref passed to the label (outer container). This allows the component to work with Tooltip */
    innerRef: PropTypes.any,

    /** Input name */
    name: PropTypes.string,
};
